module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "fixed-part"
  }, [_c('x-header', {
    staticClass: "fixed-header",
    attrs: {
      "left-options": {
        showBack: true
      }
    }
  }, [_vm._v("\n      " + _vm._s(_vm.pageTitle) + "\n      "), (!_vm.userName) ? _c('a', {
    attrs: {
      "slot": "right"
    },
    on: {
      "click": function($event) {
        _vm.goLogin()
      }
    },
    slot: "right"
  }, [_c('img', {
    staticClass: "icon",
    attrs: {
      "slot": "label",
      "src": require("../assets/icon/user-white.png"),
      "width": "18",
      "height": "18"
    },
    slot: "label"
  })]) : _vm._e(), _vm._v(" "), (_vm.userName) ? _c('a', {
    attrs: {
      "slot": "right"
    },
    on: {
      "click": function($event) {
        _vm.goLogin()
      }
    },
    slot: "right"
  }, [_vm._v("\n        " + _vm._s(_vm.userName) + "\n      ")]) : _vm._e()]), _vm._v(" "), _c('search', {
    ref: "search",
    staticClass: "fixed-search",
    attrs: {
      "results": _vm.results,
      "position": "absolute",
      "cancel-text": "搜索",
      "auto-scroll-to-top": "",
      "auto-fixed": "",
      "top": "46px"
    },
    on: {
      "on-change": _vm.getChange,
      "on-cancel": _vm.onSearch,
      "on-submit": _vm.onSearch
    },
    model: {
      value: (_vm.value),
      callback: function($$v) {
        _vm.value = $$v
      },
      expression: "value"
    }
  }), _vm._v(" "), _c('tab', {
    staticClass: "fixed-tab"
  }, [_c('tab-item', {
    attrs: {
      "selected": ""
    },
    on: {
      "on-item-click": function($event) {
        _vm.changeTab('合同')
      }
    }
  }, [_vm._v("合同"), (_vm.contractNum) ? _c('badge') : _vm._e()], 1), _vm._v(" "), _c('tab-item', {
    on: {
      "on-item-click": function($event) {
        _vm.changeTab('行政')
      }
    }
  }, [_vm._v("行政"), (_vm.attendanceNum) ? _c('badge') : _vm._e()], 1), _vm._v(" "), _c('tab-item', {
    on: {
      "on-item-click": function($event) {
        _vm.changeTab('财务')
      }
    }
  }, [_vm._v("财务"), (_vm.financeNum) ? _c('badge') : _vm._e()], 1), _vm._v(" "), _c('tab-item', {
    on: {
      "on-item-click": function($event) {
        _vm.changeTab('业务')
      }
    }
  }, [_vm._v("业务"), (_vm.businessNum) ? _c('badge') : _vm._e()], 1), _vm._v(" "), _c('tab-item', {
    on: {
      "on-item-click": function($event) {
        _vm.changeTab('人力')
      }
    }
  }, [_vm._v("人力"), (_vm.hrNum) ? _c('badge') : _vm._e()], 1), _vm._v(" "), _c('tab-item', {
    on: {
      "on-item-click": function($event) {
        _vm.changeTab('其他')
      }
    }
  }, [_vm._v("其他"), (_vm.otherNum) ? _c('badge') : _vm._e()], 1)], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "list-part"
  }, _vm._l((_vm.tabList), function(item) {
    return _c('div', {
      staticClass: "msg-items"
    }, [_c('p', {
      staticClass: "item-date"
    }, [_c('span', [_vm._v(_vm._s(item.createDate))])]), _vm._v(" "), _c('div', {
      staticClass: "item-detail"
    }, [_c('router-link', {
      attrs: {
        "to": {
          path: 'detail',
          query: {
            id: item.taskId,
            stepId: item.stepId,
            flowId: item.flowId,
            tag: _vm.tabName,
            title: item.flowName
          }
        }
      }
    }, [_c('p', {
      staticClass: "item-detail-type"
    }, [_vm._v(_vm._s(item.flowName))]), _vm._v(" "), _c('p', {
      staticClass: "item-detail-subtitle"
    }, [_vm._v("您有一个" + _vm._s(_vm.tabName) + "的申请需要处理，请点击本信息进行处理")]), _vm._v(" "), _c('p', {
      staticClass: "item-detail-title"
    }, [_vm._v("标题：" + _vm._s(_vm.tabName) + "-" + _vm._s(item.businessName))]), _vm._v(" "), _c('p', {
      staticClass: "item-detail-user"
    }, [_vm._v("申请人：" + _vm._s(item.operatorName))])])], 1)])
  }))])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-cccc8022","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/page/Todo.vue
// module id = rl6i
// module chunks = 1